export const AUTHENTICATED = 'AUTHENTICATED';
export const UNAUTHENTICATED = 'UNAUTHENTICATED';

export const SIGN_OUT_REQUEST = 'SIGN_OUT_REQUEST';

export const APP_INITIALIZED = 'APP_INITIALIZED';

export const signOut = () => ({ type: SIGN_OUT_REQUEST });
